import React from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { BalloonsIcon } from "../../../../../constant/imagePath";
import classes from "./Congrats.module.css";
import { Button } from "../../../../../stories/Button/Button";

export default function CongratsModal({ show, setShow }) {
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      footerStyles={{ padding: "0px 0px 32px 0px" }}
      borderRadius={"20px"}
      modalClass={classes.modal}
      width={"376px"}
    >
      <div className={classes.modalContent}>
        <div className={classes.imgBox}>
          <img src={BalloonsIcon} className={classes.img} />
        </div>
        <h4
          style={{
            ...Fonts.h4,
            fontSize: "26px",
            color: Colors.neutralShadesOfNero,
          }}
        >
          Congrats
        </h4>
        <p
          className={classes.firstLine}
          style={{
            ...Fonts.p2,
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          You completed your coach profile
        </p>
        <p
          className={classes.secondLine}
          style={{
            ...Fonts.p2,
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          Keep on the look out for an email confirming your coach profile in the
          next{" "}
          <span
            style={{
              ...Fonts.p2,
              color: Colors.neutralShadesOfNero,
            }}
          >
            48 hours.
          </span>
          Once we confirm your coach status, you can start scheduling lessons on
          Lytesnap!
        </p>
        <p
          style={{
            ...Fonts.p2,
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          There’s no further action you need to take now.
        </p>

        <div className={classes.btnBox}>
          <Button
            label={"Got to homepage"}
            primary={true}
            size={"Large"}
            onClick={() => setShow(false)}
          />
        </div>

      </div>
    </ModalSkeleton>
  );
}
